import axios from '../axios'
import { EVENTCANDIDATEROUTES } from 'src/router/Api'

// On a row of the custom events list: null for a normal event, an object for
// an event the finder created that still waits for review.
export interface EventPendingReview {
	candidate_id: string
	host_name: string | null
	host_contact_url: string | null
	source_url: string | null
	// Short codes for what the finder assumed or could not find.
	review_notes: string[]
}

export interface EventCandidateRunParams {
	city?: string
	limit?: number
}

// POST /event-candidate/run answers at once; the run goes on in the background.
export interface EventCandidateRunStart {
	started?: boolean
	reason?: string | null
}

export interface EventCandidateRunCity {
	city?: string | null
	country?: string | null
	found?: number | null
	created?: number | null
	// Reason code to count.
	dropped?: Record<string, number> | null
	error?: string | null
}

// GET /event-candidate/run/status: the latest run. Timestamps are epoch ms.
export interface EventCandidateRunStatus {
	running?: boolean
	started_at?: number | string | null
	finished_at?: number | string | null
	found?: number | null
	created?: number | null
	dropped?: Record<string, number> | null
	cities?: EventCandidateRunCity[] | null
	skipped?: unknown
	// New events allowed per day, and how many were already created today when the run began.
	daily_limit?: number | null
	created_today?: number | null
	error?: string | null
}

// Makes the pending event visible to app users.
export const approvePendingEvent = async (postId: string) => {
	return await axios.post(EVENTCANDIDATEROUTES.approvePost(postId))
}
// Deletes the pending event and its future repeats.
export const rejectPendingEvent = async (postId: string) => {
	return await axios.post(EVENTCANDIDATEROUTES.rejectPost(postId))
}
export const runEventCandidateJob = async (
	params: EventCandidateRunParams = {},
) => {
	return await axios.post(EVENTCANDIDATEROUTES.run, params)
}
export const getEventCandidateRunStatus = async () => {
	return await axios.get(EVENTCANDIDATEROUTES.runStatus)
}
